const getters = {
  auth: (state) => state.auth,
  common: (state) => state.common,
  interface: (state) => state.interface,
  alarm: (state) => state.alarm,
  dataset: (state) => state.dataset,
  task: (state) => state.task,
  dashboard: (state) => state.dashboard,
  wsd: (state) => state.wsd,
  testspace: (state) => state.testspace,
  admin: (state) => state.admin,
  testTab: (state) => state.testTab,
};
export default getters;
